import { useState } from "react";

import { makePostApiCall, makePutApiCall } from "../../../shared/makeApiCall";
import ClaimsForm from "../../../components/forms/setup/claims/ClaimsForm";
import DeleteConfirmationForm from "../../../components/forms/DeleteConfirmationForm";
import { SnackbarData, SnackbarType } from "../../../components/Snackbar";
import { generateUniqueNumber } from "../../../shared/utility";

export function ClaimsViewModel(logout, addSnackbar) {
  const [emptyModal, setEmptyModelOpen] = useState({
    open: false,
    childComponent: null,
  });
  const [loading, setLoading] = useState(false);
  const [claims, setClaims] = useState({ data: [] });
  const [slideOver, setSlideOver] = useState({
    childComponent: null,
    open: false,
  });


  const getClaims = async function (search, page) {
    setLoading(true);
    const payload = {
      page: page,
      search: search,
    };
    let callResult = await makePostApiCall(`claims`, payload);
    setLoading(false);
    if (callResult.success) {
      setClaims(callResult.data);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const createClaim = async function (values) {
    const payload = { ...values };
    let callResult = await makePostApiCall("createClaim", payload);

    if (callResult.success) {
      addSnackbar(
        new SnackbarData(
          generateUniqueNumber(),
          "Claim added",
          SnackbarType.Success,
        ),
      );
      setSlideOver({
        childComponent: null,
        open: false,
      });
      setTimeout(function () {
        getClaims("", 1);
      }, 1000);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const updateClaim = async function (claim, values, index) {
    let callResult = await makePutApiCall(`claims/${claim.id}`, values);

    if (callResult.success) {
      addSnackbar(
        new SnackbarData(
          generateUniqueNumber(),
          "Claim updated",
          SnackbarType.Success,
        ),
      );
      setSlideOver({
        childComponent: null,
        open: false,
      });
      setTimeout(function () {
        getClaims("", 1);
      }, 1000);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const openAddClaimSlideOver = () => {
    setSlideOver({
      childComponent: (
        <ClaimsForm
          isEdit={false}
          setOpen={setSlideOver}
          actionCall={createClaim}
        />
      ),
      open: true,
    });
  };

  const viewClaimDetails = async function (claim, index) {
    setSlideOver({
      childComponent: (
        <ClaimsForm
          claim={claim}
          index={index}
          isEdit={true}
          setOpen={setSlideOver}
          actionCall={updateClaim}
        />
      ),
      open: true,
    });
  };

  const deleteClaim = async function (id, index) {
    setLoading(true);

    let callResult = await makePostApiCall(`deleteClaim/${id}`, {});
    setLoading(false);
    if (callResult.success) {
      setEmptyModelOpen({
        open: false,
        childComponent: null,
      });
      getClaims(null, 0);
      addSnackbar(
        new SnackbarData(
          generateUniqueNumber(),
          callResult.data.message,
          SnackbarType.Success,
        ),
      );
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const askDeleteClaim = function (claim, index) {
    setEmptyModelOpen({
      childComponent: (
        <DeleteConfirmationForm
          buttonMessage="Delete"
          confirmAction={() => deleteClaim(claim.id, index)}
          message={`Are you sure you want to delete ${claim.name}?`}
          setOpen={setEmptyModelOpen}
        />
      ),
      open: true,
    });
  };

  return {
    askDeleteClaim,
    emptyModal,
    setEmptyModelOpen,
    createClaim,
    getClaims,
    loading,
    claims,
    openAddClaimSlideOver,
    setSlideOver,
    slideOver,
    updateClaim,
    viewClaimDetails,
  };
}
